/**
 * Scarf pattern swatches for /products/club-scarves.
 *
 * Dawn's product-info.js re-renders <variant-selects> on every variant change
 * by inserting a fresh copy then removing the old one (HTMLUpdateUtility.viewTransition).
 * Anything inside <variant-selects> gets wiped.
 *
 * Fix:
 *  1. Inject a <style> into <head> that permanently hides the pill fieldset inside
 *     any <variant-selects> on this page — CSS fires instantly on new nodes, JS doesn't.
 *  2. Place the swatch grid as a sibling BEFORE <variant-selects> so Dawn's replacement
 *     never touches it. The grid lives forever.
 */
(function () {
  if (!window.location.pathname.match(/\/products\/club-scarves/)) return;

  // ── 1. Inject permanent CSS so pills never flash, even in freshly-rendered nodes ──
  const styleTag = document.createElement('style');
  styleTag.id = 'cc-scarf-hide-pills';
  styleTag.textContent = `
    variant-selects fieldset.product-form__input--pill {
      display: none !important;
    }
  `;
  document.head.appendChild(styleTag);

  // ── 2. Build the persistent swatch grid (inserted once, lives outside variant-selects) ──

  let currentTitle = '';

  function buildImgMap(product) {
    const map = {};
    for (const v of product.variants) {
      if (v.featured_image?.src) {
        map[v.title] = v.featured_image.src;
      } else {
        const img = product.images.find(i => i.id === v.image_id);
        if (img) map[v.title] = img.src;
      }
    }
    return map;
  }

  function buildGrid(product, imgMap) {
    const wrapper = document.createElement('div');
    wrapper.className = 'cc-scarf-swatches-wrapper';
    wrapper.id = 'cc-scarf-swatches-root';

    // Label row
    const labelRow = document.createElement('div');
    labelRow.className = 'cc-scarf-swatches-label form__label';
    labelRow.innerHTML = 'Style: <span class="cc-scarf-selected-label"></span>';
    wrapper.appendChild(labelRow);

    const grid = document.createElement('div');
    grid.className = 'cc-scarf-swatches';
    wrapper.appendChild(grid);

    function setActive(title) {
      currentTitle = title;
      grid.querySelectorAll('.cc-scarf-swatch').forEach(s => {
        const active = s.dataset.title === title;
        s.classList.toggle('cc-scarf-swatch--active', active);
        s.setAttribute('aria-pressed', String(active));
      });
      wrapper.querySelector('.cc-scarf-selected-label').textContent = title;
    }

    for (const v of product.variants) {
      const src = imgMap[v.title];
      if (!src) continue;

      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'cc-scarf-swatch';
      btn.dataset.title = v.title;
      btn.title = v.title;
      btn.setAttribute('aria-pressed', 'false');

      const img = document.createElement('img');
      img.src = src.replace(/\?.*$/, '') + '?width=200';
      img.alt = v.title;
      img.loading = 'lazy';

      const num = document.createElement('span');
      num.className = 'cc-scarf-swatch__label';
      num.textContent = v.title.replace('Style ', '');

      btn.appendChild(img);
      btn.appendChild(num);

      btn.addEventListener('click', () => {
        // Update visual state immediately — no waiting for Dawn
        setActive(v.title);
        // Find the radio in variant-selects (may have been re-rendered, so query fresh)
        const radio = document.querySelector(
          `variant-selects input[type="radio"][value="${CSS.escape(v.title)}"]`
        );
        if (radio) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });

      grid.appendChild(btn);
    }

    // Set initial active from the currently checked radio
    const checkedRadio = document.querySelector(
      'variant-selects input[type="radio"]:checked'
    );
    if (checkedRadio) setActive(checkedRadio.value);

    return wrapper;
  }

  function init() {
    fetch('/products/club-scarves.json')
      .then(r => r.json())
      .then(({ product }) => {
        const imgMap = buildImgMap(product);
        const grid = buildGrid(product, imgMap);

        // Insert before <variant-selects> — outside it, so re-renders never wipe it
        const variantSelects = document.querySelector('variant-selects');
        if (!variantSelects) return;
        variantSelects.parentElement.insertBefore(grid, variantSelects);
      })
      .catch(() => {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
